import React from 'react'
import PropTypes from 'prop-types'

const LayerText = ({ index, lyr, errorLayers, setErrorLayers, setMessage }) => {
    const onChange = e => {
        const newLayers = errorLayers
        newLayers[index].error = e
        setErrorLayers(newLayers)
        setMessage(e)
    }

    return (
        <div className="error-layer-details">
            <textarea
                className="textarea"
                rows="3"
                index={index}
                onChange={e => onChange(e.target.value)}
                placeholder="Please describe the issue"
                value={lyr.error}
            ></textarea>
        </div>
    )
}

LayerText.propTypes = {
    index: PropTypes.number,
    lyr: PropTypes.object,
    errorLayers: PropTypes.array,
    setErrorLayers: PropTypes.func,
    setMessage: PropTypes.func
}

export default LayerText
